'use client';
import React, { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="page-width">
          <div className="footer-content">
            {/* Quick Links */}
            <div className="footer-col">
              <p className="footer-heading">Quick links</p>
              <ul className="footer-links">
                {[
                  { label: 'Coffee', href: '#shop' },
                  { label: 'Gifts and Gear', href: '#gear' },
                  { label: 'Search', href: '#' },
                  { label: 'Where to Buy', href: '#locations' },
                  { label: 'Contact Us', href: '#contact' },
                ].map((link) => (
                  <li key={link.label} className="footer-link-item">
                    <a href={link.href} className="footer-link">{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div className="footer-col">
              <p className="footer-heading">Subscribe for updates</p>
              <div className="newsletter-wrap">
                {subscribed ? (
                  <p className="subscribed-msg">Thanks for subscribing!</p>
                ) : (
                  <form onSubmit={handleSubscribe} className="newsletter-form">
                    <div className="input-group">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email address"
                        aria-label="Email address"
                        required
                        className="newsletter-input"
                      />
                      <button type="submit" className="newsletter-btn">Subscribe</button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="footer-hr" />

      <div className="footer-bottom">
        <div className="page-width">
          <div className="footer-bottom-inner">
            {/* Social Icons */}
            <div className="social-icons">
              <a
                href="http://facebook.com/baysidecoffeeco"
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 20 20" width="20" height="20">
                  <path fill="#444" d="M18.05.811q.439 0 .744.305t.305.744v16.637q0 .439-.305.744t-.744.305h-4.732v-7.221h2.415l.342-2.854h-2.757v-1.83q0-.659.293-1t1.073-.342h1.488V3.762q-.976-.098-2.171-.098-1.634 0-2.635.964t-1 2.72V9.47H7.951v2.854h2.415v7.221H1.413q-.439 0-.744-.305t-.305-.744V1.859q0-.439.305-.744T1.413.81H18.05z" />
                </svg>
                <span className="social-label">Facebook</span>
              </a>
              <a
                href="https://www.instagram.com/baysidecoffeeco_fl/"
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 512 512" width="20" height="20">
                  <path fill="#444" d="M256 49.5c67.3 0 75.2.3 101.8 1.5 24.6 1.1 37.9 5.2 46.8 8.7 11.8 4.6 20.2 10 29 18.8s14.3 17.2 18.8 29c3.4 8.9 7.6 22.2 8.7 46.8 1.2 26.6 1.5 34.5 1.5 101.8s-.3 75.2-1.5 101.8c-1.1 24.6-5.2 37.9-8.7 46.8-4.6 11.8-10 20.2-18.8 29s-17.2 14.3-29 18.8c-8.9 3.4-22.2 7.6-46.8 8.7-26.6 1.2-34.5 1.5-101.8 1.5s-75.2-.3-101.8-1.5c-24.6-1.1-37.9-5.2-46.8-8.7-11.8-4.6-20.2-10-29-18.8s-14.3-17.2-18.8-29c-3.4-8.9-7.6-22.2-8.7-46.8-1.2-26.6-1.5-34.5-1.5-101.8s.3-75.2 1.5-101.8c1.1-24.6 5.2-37.9 8.7-46.8 4.6-11.8 10-20.2 18.8-29s17.2-14.3 29-18.8c8.9-3.4 22.2-7.6 46.8-8.7 26.6-1.3 34.5-1.5 101.8-1.5m0-45.4c-68.4 0-77 .3-103.9 1.5C125.3 6.8 107 11.1 91 17.3c-16.6 6.4-30.6 15.1-44.6 29.1-14 14-22.6 28.1-29.1 44.6-6.2 16-10.5 34.3-11.7 61.2C4.4 179 4.1 187.6 4.1 256s.3 77 1.5 103.9c1.2 26.8 5.5 45.1 11.7 61.2 6.4 16.6 15.1 30.6 29.1 44.6 14 14 28.1 22.6 44.6 29.1 16 6.2 34.3 10.5 61.2 11.7 26.9 1.2 35.4 1.5 103.9 1.5s77-.3 103.9-1.5c26.8-1.2 45.1-5.5 61.2-11.7 16.6-6.4 30.6-15.1 44.6-29.1 14-14 22.6-28.1 29.1-44.6 6.2-16 10.5-34.3 11.7-61.2 1.2-26.9 1.5-35.4 1.5-103.9s-.3-77-1.5-103.9c-1.2-26.8-5.5-45.1-11.7-61.2-6.4-16.6-15.1-30.6-29.1-44.6-14-14-28.1-22.6-44.6-29.1-16-6.2-34.3-10.5-61.2-11.7-27-1.1-35.6-1.4-104-1.4z" />
                  <path fill="#444" d="M256 126.6c-71.4 0-129.4 57.9-129.4 129.4s58 129.4 129.4 129.4 129.4-58 129.4-129.4-58-129.4-129.4-129.4zm0 213.4c-46.4 0-84-37.6-84-84s37.6-84 84-84 84 37.6 84 84-37.6 84-84 84z" />
                  <circle fill="#444" cx="390.5" cy="121.5" r="30.2" />
                </svg>
                <span className="social-label">Instagram</span>
              </a>
            </div>

            {/* Copyright */}
            <div className="copyright">
              <small>
                © 2026,{' '}
                <a href="#" className="copyright-link">Bayside Coffee Co.</a>
              </small>
              <small>
                {' '}·{' '}
                <a
                  href="https://www.shopify.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="copyright-link"
                >
                  Powered by Shopify
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .site-footer {
          background: #f5f5f5;
          color: #3d4246;
          font-family: 'Work Sans', sans-serif;
        }
        .footer-top {
          padding: 40px 0;
        }
        .page-width {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .footer-content {
          display: flex;
          gap: 40px;
          flex-wrap: wrap;
        }
        .footer-col {
          flex: 1;
          min-width: 200px;
        }
        .footer-heading {
          font-size: 16px;
          font-weight: 600;
          color: #3d4246;
          margin: 0 0 16px 0;
          font-family: 'Work Sans', sans-serif;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .footer-links {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          gap: 0;
        }
        .footer-link-item {
          margin-right: 16px;
          margin-bottom: 8px;
        }
        .footer-link {
          color: #3d4246;
          text-decoration: none;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
          transition: color 0.2s;
        }
        .footer-link:hover {
          color: #61696f;
        }
        .newsletter-wrap {
          max-width: 400px;
        }
        .newsletter-form {
          width: 100%;
        }
        .input-group {
          display: flex;
          border: 1px solid #dcdcdc;
          overflow: hidden;
        }
        .newsletter-input {
          flex: 1;
          padding: 10px 14px;
          border: none;
          outline: none;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
          color: #3d4246;
          background: #fff;
        }
        .newsletter-btn {
          padding: 10px 18px;
          background: #3d4246;
          color: #fff;
          border: none;
          cursor: pointer;
          font-size: 14px;
          font-family: 'Work Sans', sans-serif;
          font-weight: 500;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          transition: background 0.2s;
        }
        .newsletter-btn:hover {
          background: #557b97;
        }
        .subscribed-msg {
          color: #557b97;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
        }
        .footer-hr {
          border: none;
          border-bottom: 1px solid #dcdcdc;
          margin: 0;
        }
        .footer-bottom {
          padding: 20px 0;
        }
        .footer-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        .social-icons {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        .social-link {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #3d4246;
          text-decoration: none;
          transition: color 0.2s;
        }
        .social-link:hover {
          color: #61696f;
        }
        .social-label {
          font-size: 13px;
          font-family: 'Work Sans', sans-serif;
        }
        .copyright {
          font-size: 13px;
          color: #3d4246;
          font-family: 'Work Sans', sans-serif;
        }
        .copyright-link {
          color: #3d4246;
          text-decoration: none;
          transition: color 0.2s;
        }
        .copyright-link:hover {
          color: #61696f;
        }
        @media (max-width: 749px) {
          .footer-content {
            flex-direction: column;
          }
          .footer-bottom-inner {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
